import React, { useEffect, useState } from 'react'

import Chevron from './ChevronSvg';
import { Button, ButtonAccount, ButtonLabel, ButtonName, DropDown, Wrapper } from './Style';
import { defaultTypes } from './StyleType';
import TmpIconCustom from '../TmpIconCustom/TmpIconCustom';
import TmpListItemCustom from '../TmpListItemCustom/TmpListItemCustom';
import TmpAvatarCustom from '../TmpAvatarCustom/TmpAvatarCustom';


interface TmpDropdownProfileCustomProps {
    name: string;
    accountName: number | undefined;
    itens: TmpDropdownProfileItemsCustomProps[];
}

export interface TmpDropdownProfileItemsCustomProps {
    label: string;
    handleClick: (e: any) => void;
}

export default function TmpDropdownProfileCustom(props: TmpDropdownProfileCustomProps) {

    const [_actived, setActived] = useState(false);
    const [initialCharactersFromName, setInitialCharactersFromName] = useState<string>("");

    Button.defaultProps = defaultTypes;
    ButtonName.defaultProps = defaultTypes;
    ButtonAccount.defaultProps = defaultTypes;
    DropDown.defaultProps = defaultTypes;

    useEffect(() => {
        setActived(false);
    }, []);

    useEffect(() => {

        if (props.name !== "" && props.name !== undefined && props.name !== null) {

            var firstLetterFromName = props.name[0];
            var words = props.name.split(" ");
            var lastLetterFromName = words[words.length - 1][0];

            setInitialCharactersFromName(firstLetterFromName + lastLetterFromName);
        }
    }, [props.name]);

    const _handleClick = () => {
        const status = !_actived;
        setActived(status);
    };

    return (
        <React.Fragment>
            <Wrapper >
                <Button onClick={_handleClick} actived={_actived}>
                    <TmpAvatarCustom
                        size="sm"
                        initials={initialCharactersFromName}
                    />
                    <ButtonLabel>
                        <ButtonName>Olá, {props.name}</ButtonName>
                        <ButtonAccount>{props.accountName}</ButtonAccount>
                    </ButtonLabel>
                    <TmpIconCustom size="sm" icon={<Chevron />} />
                </Button>
                <DropDown actived={_actived}>
                    {props.itens.map((item: TmpDropdownProfileItemsCustomProps, index) => (
                        <TmpListItemCustom
                            key={index}
                            label={item.label}
                            handleClick={item.handleClick}
                        />
                    ))}
                </DropDown>
            </Wrapper>
        </React.Fragment >
    )
}


